// Cupom do Payments Hub: chega por ?cupom= (ou ?coupon=) em qualquer página e fica guardado até o checkout.
// O desconto é calculado e validado só no servidor (Payments Hub); aqui é apenas o código digitado.
const KEY = 'laudando_coupon';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const CODE = /^[A-Z0-9_-]{3,32}$/;

export const normalizeCoupon = (value) => {
  const code = String(value ?? '').trim().toUpperCase();
  return CODE.test(code) ? code : null;
};

const storage = () => { try { return typeof window === 'undefined' ? null : window.localStorage; } catch { return null; } };

export const captureCouponFromUrl = (search = typeof window === 'undefined' ? '' : window.location.search, now = Date.now()) => {
  const params = new URLSearchParams(search);
  const code = normalizeCoupon(params.get('cupom') ?? params.get('coupon'));
  if (!code) return null;
  try { storage()?.setItem(KEY, JSON.stringify({ code, at: now })); } catch { /* armazenamento indisponível */ }
  return code;
};

export const getStoredCoupon = (now = Date.now()) => {
  try {
    const raw = storage()?.getItem(KEY);
    if (!raw) return null;
    const { code, at } = JSON.parse(raw);
    if (!normalizeCoupon(code) || !(now - Number(at) < TTL_MS)) { storage()?.removeItem(KEY); return null; }
    return code;
  } catch { return null; }
};

export const storeCoupon = (code, now = Date.now()) => {
  try { if (normalizeCoupon(code)) storage()?.setItem(KEY, JSON.stringify({ code: normalizeCoupon(code), at: now })); } catch { /* sem armazenamento */ }
};

export const clearStoredCoupon = () => { try { storage()?.removeItem(KEY); } catch { /* sem armazenamento */ } };
